export default {
    state: {
        userImgUrl: 'http://mpicture.iartschool.com/',
        userVideoUrl: 'http://mvod.iartschool.com/',
        shareUrl:location.origin+'/#',
        userinfo: '',
        keepAlive: [],
        defaultHeaderimg: 'http://image.iartschool.com/headerimg.png',
        shareIcon: 'http://picture.iartschool.com/20200211/676831665854611456.jpg',
        androidUrl:
        "https://sj.qq.com/myapp/detail.htm?apkName=com.iartschool.app.iart_school",
      iosUrl: "https://apps.apple.com/cn/app/id1146337839",
    }
}